<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col">
        <div v-if="success" class="mt-4">
          <programa-tab :process="process">
            <div slot="footer">
              <div class="card-footer text-center">
                <base-alert type="success" class="mb-0">{{
                  process.finished_message
                    ? process.finished_message
                    : "Inscrição realizada com sucesso!"
                }}</base-alert>
                <hr class="my-4" />
                <p>
                  Confira abaixo o resultado do seu teste de perfil
                  comportamental. O método DISC compreende que existem quatro
                  perfis de comportamentos que predomina entre os indivíduos:
                  <span
                    @click="openModalDisc('dominante')"
                    class="cursor-pointer"
                    ><b>Dominante</b>
                    <i
                      class="fas fa-eye cursor-pointer ml-1 text-primary"
                      title="Visualizar detalhes"
                    ></i></span
                  >,
                  <span
                    @click="openModalDisc('influente')"
                    class="cursor-pointer"
                    ><b>Influente</b>
                    <i
                      class="fas fa-eye cursor-pointer ml-1 text-primary"
                      title="Visualizar detalhes"
                    ></i></span
                  >,
                  <span @click="openModalDisc('estavel')" class="cursor-pointer"
                    ><b>Estável</b>
                    <i
                      class="fas fa-eye cursor-pointer ml-1 text-primary"
                      title="Visualizar detalhes"
                    ></i
                  ></span>
                  e
                  <span
                    @click="openModalDisc('condescendente')"
                    class="cursor-pointer"
                    ><b>Condescendente</b>
                    <i
                      class="fas fa-eye cursor-pointer ml-1 text-primary"
                      title="Visualizar detalhes"
                    ></i></span
                  >.
                </p>
                <apexchart
                  class="border rounded my-3"
                  :height="400"
                  :options="chartOptions"
                  :series="chartSeries"
                ></apexchart>
                <img
                  src="/img/pages/disc_tbl.png"
                  class="img-fluid border rounded"
                />
              </div>
            </div>
          </programa-tab>
        </div>
        <div v-else-if="error" class="mt-6 text-center">
          <base-alert type="danger"
            >Ocorreu um erro ao recuperar as informações. Por favor, verifique o
            endereço informado e tente novamente.</base-alert
          >
        </div>
        <form-wizard color="#ff4200" v-else>
          <template slot="title">
            <div class="col-12">
              <h3 class="text-light font-weight-normal">Ficha de Inscrição</h3>
            </div>
          </template>
          <!-- Programa -->
          <tab-content title="Programa" icon="ni ni-planet">
            <div class="vld-parent" ref="programa_container">
              <programa-tab :process="process" />
            </div>
          </tab-content>
          <!-- Currículo -->
          <tab-content
            title="Currículo"
            icon="fas fa-clipboard-list"
            :before-change="() => validateCv()"
          >
            <div class="card card-profile shadow">
              <div class="card-body mt-2 py-3">
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Informações básicas
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-12">
                    <base-input
                      label="Nome completo*"
                      v-model="model.name"
                      placeholder="Digite seu nome completo"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label"
                      >Telefone celular (com DDD)*</label
                    >
                    <base-input addonLeftIcon="fab fa-whatsapp">
                      <the-mask
                        :mask="['(##) ####-####', '(##) #####-####']"
                        v-model="model.phone"
                        class="form-control"
                        type="tel"
                        placeholder="Digite seu telefone celular"
                      ></the-mask>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <span class="form-control-label">Email*</span>
                    <base-input
                      addon-left-icon="ni ni-email-83"
                      v-model="model.email"
                      placeholder="Digite seu endereço de email"
                    />
                  </div>
                  <div class="col-lg-12">
                    <estados
                      estadoLabel="Estado*"
                      cidadeLabel="Cidade*"
                      :selectedEstado="model.state"
                      :selectedCidade="model.city"
                      @inputEstado="model.state = $event"
                      @inputCidade="model.city = $event"
                    />
                  </div>
                  <div class="col-lg-12">
                    <label for="" class="form-control-label d-block"
                      >LinkedIn</label
                    >
                    <base-input
                      addon-left-icon="fab fa-linkedin"
                      v-model="model.linkedin_url"
                      placeholder="Cole o link aqui"
                    />
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">O que você busca?</h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-12">
                    <label class="form-control-label">
                      Selecione as opções que mais se adequam a você*
                    </label>
                  </div>
                  <div class="col-lg-12 mt-2 ml-lg-2">
                    <base-input>
                      <base-checkbox
                        v-for="(option, index) in areas"
                        :key="'area_' + index"
                        class="mb-2 mr-1"
                        @input="handleAreaSelected(option, $event)"
                        :checked="model.areas.includes(option)"
                      >
                        <span class="ml--3">{{ option }}</span>
                      </base-checkbox>
                    </base-input>
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Dados pessoais</h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <base-input
                      label="Com qual identidade de gênero você se identifica?*"
                    >
                      <select class="form-control" v-model="model.gender">
                        <option selected disabled value="">
                          Selecione uma opção
                        </option>
                        <option
                          v-for="gender in genders"
                          :key="gender"
                          :value="gender"
                        >
                          {{ gender }}
                        </option>
                      </select>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input label="Estado civil*">
                      <select class="form-control" v-model="model.civil_status">
                        <option selected disabled value="">
                          Selecione uma opção
                        </option>
                        <option
                          v-for="cstatus in civilStatus"
                          :key="cstatus"
                          :value="cstatus"
                        >
                          {{ cstatus }}
                        </option>
                      </select>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      class="mb-0"
                      label="Data de nascimento*"
                      type="date"
                      v-model="model.birthday"
                      placeholder="Data de nascimento"
                    />
                    <p
                      class="description mb-2 text-right"
                      v-if="model.birthday"
                    >
                      {{ getAge(model.birthday) }} anos
                    </p>
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Nacionalidade*"
                      v-model="model.nationality"
                      placeholder="Digite sua nacionalidade"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label d-block"
                      >Site pessoal ou blog (caso tenha)</label
                    >
                    <base-input
                      addon-left-icon="fas fa-home"
                      v-model="model.homepage_url"
                      placeholder="Cole o link aqui"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label d-block"
                      >GitHub (opcional caso seja programador)</label
                    >
                    <base-input
                      addon-left-icon="fab fa-github"
                      v-model="model.github_url"
                      placeholder="Cole o link aqui"
                    />
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Formação</h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div
                    class="col-12"
                    v-for="(ed, index) in model.education"
                    :key="'ed_' + index"
                  >
                    <div class="row" v-if="index > 0">
                      <div class="col-6 offset-3">
                        <hr class="my-2" />
                      </div>
                    </div>
                    <p class="description">
                      Formação {{ index + 1
                      }}<b
                        v-if="index === 0"
                        title="Pelo menos uma formação deve ser infomada"
                        >*</b
                      >
                      <span class="text-danger" v-else>
                        <i
                          class="fas fa-trash cursor-pointer float-right"
                          title="'Remover formação'"
                          @click="removeEducation(index)"
                        ></i>
                      </span>
                    </p>
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input
                          label="Curso"
                          v-model="ed.course"
                          placeholder="Digite o nome do curso"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          label="Instituição"
                          v-model="ed.institution"
                          placeholder="Digite o nome da instituição"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          label="Início"
                          type="month"
                          v-model="ed.start"
                          placeholder="Início"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          label="Término"
                          type="month"
                          v-model="ed.end"
                          placeholder="Término"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          label="Duração"
                          v-model="ed.duration"
                          placeholder="Informe a duração"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input label="Situação">
                          <select class="form-control" v-model="ed.status">
                            <option selected disabled value="">
                              Selecione uma opção
                            </option>
                            <option
                              v-for="status in [
                                'Em andamento',
                                'Trancado',
                                'Concluído',
                              ]"
                              :key="status"
                              :value="status"
                            >
                              {{ status }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 text-right">
                    <base-button
                      class="btn btn-sm btn-primary"
                      @click="addEducation()"
                      >Adicionar formação</base-button
                    >
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Resumo profissional
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div
                    v-for="(ex, index) in model.experiences"
                    :key="'ex_' + index"
                    class="col-12"
                  >
                    <div class="row" v-if="index > 0">
                      <div class="col-6 offset-3">
                        <hr class="my-2" />
                      </div>
                    </div>
                    <p class="description">
                      Experiência profissional {{ index + 1 }}
                      <span class="text-danger" v-if="index > 0">
                        <i
                          class="fas fa-trash cursor-pointer float-right"
                          title="Remover experiência"
                          @click="removeExperience(index)"
                        ></i>
                      </span>
                    </p>
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input
                          label="Cargo"
                          v-model="ex.position"
                          placeholder="Digite o nome do cargo ocupado"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          label="Empresa"
                          v-model="ex.company"
                          placeholder="Digite o nome da empresa"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          label="Início"
                          type="month"
                          v-model="ex.start"
                          placeholder="Início"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          label="Término"
                          type="month"
                          v-model="ex.end"
                          placeholder="Término"
                        />
                      </div>
                      <div class="col-lg-12">
                        <base-input label="Atribuições">
                          <textarea
                            rows="2"
                            class="form-control"
                            placeholder="Digite aqui..."
                            v-model="ex.attributions"
                          >
                          </textarea>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 text-right">
                    <base-button
                      class="btn btn-sm btn-primary"
                      @click="addExperience()"
                      >Adicionar experiência</base-button
                    >
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Idiomas</h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div
                    v-for="(id, index) in model.languages"
                    :key="'id_' + index"
                    class="col-12"
                  >
                    <div class="row" v-if="index > 0">
                      <div class="col-6 offset-3">
                        <hr class="my-2" />
                      </div>
                    </div>
                    <p class="description">
                      Idioma {{ index + 1 }}
                      <span class="text-danger" v-if="index > 0">
                        <i
                          class="fas fa-trash cursor-pointer float-right"
                          title="Remover idioma"
                          @click="removeLanguage(index)"
                        ></i>
                      </span>
                    </p>
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input
                          label="Idioma"
                          v-model="id.language"
                          placeholder="Digite o nome do idioma"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input label="Nível de proeficiência">
                          <select class="form-control" v-model="id.level">
                            <option selected disabled value="">
                              Selecione uma opção
                            </option>
                            <option
                              v-for="status in [
                                'Básico',
                                'Intermediário',
                                'Avançado',
                                'Fluente',
                              ]"
                              :key="status"
                              :value="status"
                            >
                              {{ status }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 text-right">
                    <base-button
                      class="btn btn-sm btn-primary"
                      @click="addLanguage()"
                      >Adicionar idioma</base-button
                    >
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Portifólio</h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-12">
                    <p>
                      Você tem um portfólio e gostaria de compartilhar conosco?
                    </p>
                    <div>
                      <file-select
                        v-model="portfolio"
                        title="Selecione o arquivo"
                        type="primary"
                        accept="application/pdf"
                        :mbSize="10"
                      ></file-select>
                    </div>
                    <p class="description text-muted">
                      <i class="fas fa-image mr-2"></i>
                      deve ser do formato
                      <b class="font-weight-bold">PDF</b> e ter um tamanho
                      máximo de <b class="font-weight-bold">10MB</b>.
                    </p>
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Informações complementares
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-12">
                    <p>
                      Deseja adicionar alguma informação? (até 1.500 caracteres)
                    </p>
                    <div class="col-lg-12">
                      <base-input class="mb-0">
                        <textarea
                          rows="4"
                          class="form-control"
                          placeholder="Também é possível utilizar este espaço falar um pouco mais sobre você! :)"
                          v-model="model.note"
                          maxlength="1500"
                        >
                        </textarea>
                      </base-input>
                      <p class="description mb-1 text-right">
                        <b>{{ 1500 - model.note.length }}</b> caracteres
                        restantes
                      </p>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <base-alert type="default">{{
                    errors.stepError.text
                  }}</base-alert>
                </div>
              </div>
            </div>
          </tab-content>
          <!-- DISC -->
          <tab-content
            title="DISC"
            icon="fas fa-chart-pie"
            :before-change="() => validateDisc()"
          >
            <div class="card card-profile shadow">
              <div class="card-body mt-2 py-3">
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Preenchimento do teste de Perfil comportamental (DISC)
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-12 mb-2">
                    <p class="font-weight-bold">
                      Instruções para a realização do questionário:
                    </p>
                    <p>
                      Analise as opções em cada pergunta e enumere-as de 1 a 4.
                      A opção com a qual você <b>MAIS</b> se identifica, insira
                      o NÚMERO <b>4</b> na respectiva caixinha, e aquela com a
                      qual você <b>MENOS</b> tem afinidade, assinale com um
                      NÚMERO <b>1</b>.
                    </p>
                    <p>
                      <b>NÃO PENSE MUITO PARA RESPONDER</b>, o primeiro
                      pensamento que vem à mente é o <b>mais instintivo</b>,
                      <b>livre de filtros</b> ou <b>direcionamentos</b>.
                    </p>
                    <p>
                      Uma vez terminado o questionário, você saberá que estilo
                      de comportamento é o seu estilo principal.
                      <b>Vamos lá?!</b>
                    </p>
                  </div>
                  <div
                    class="col-12"
                    v-for="(question, index) in survey"
                    :key="'question_' + index"
                  >
                    <div class="row" v-if="index > 0">
                      <div class="col-6 offset-3">
                        <hr class="my-4" />
                      </div>
                    </div>
                    <p class="font-weight-bold mb-0 pb-1">
                      {{ index + 1 }}. {{ question.question }}
                    </p>
                    <div
                      class="row"
                      v-for="(option, indexOpt) in ['A', 'B', 'C', 'D']"
                      :key="'opt_' + indexOpt"
                    >
                      <div class="col-12">
                        <p class="mb-0 pl-2">
                          <select
                            class="form-control d-inline-block w-auto mr-1 mb-1"
                            v-model="question.answers[indexOpt]"
                          >
                            <option selected value="">__</option>
                            <option
                              v-for="opt in getRemainingOptions(
                                indexOpt,
                                question.answers
                              )"
                              :key="`q_${index}_opt_${indexOpt}_${opt}`"
                            >
                              {{ opt }}
                            </option>
                          </select>
                          {{ option }}. {{ question.options[indexOpt] }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.discError.show">
                  <base-alert type="default">{{
                    errors.discError.text
                  }}</base-alert>
                </div>
                <div
                  class="text-center mt-4 error"
                  v-else-if="errors.submitError.show"
                >
                  <base-alert type="danger">{{
                    errors.submitError.text
                  }}</base-alert>
                </div>
              </div>
            </div>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div v-if="process.status === 'open' && !success">
              <div class="wizard-footer-left">
                <wizard-button
                  v-if="props.activeTabIndex > 0"
                  @click.native="props.prevTab()"
                  :style="props.fillButtonStyle"
                  ><i class="fas fa-chevron-left mr-2"></i>
                  Voltar</wizard-button
                >
              </div>
              <div class="wizard-footer-right">
                <wizard-button
                  v-if="!props.isLastStep"
                  @click.native="props.nextTab()"
                  class="wizard-footer-right"
                  :style="props.fillButtonStyle"
                  >Avançar
                  <i class="fas fa-chevron-right ml-2"></i>
                </wizard-button>
                <wizard-button
                  v-else
                  @click.native="onComplete()"
                  class="wizard-footer-right finish-button"
                  :style="props.fillButtonStyle"
                  >Concluir inscrição <i class="fas fa-check-circle ml-1"></i
                ></wizard-button>
              </div>
            </div>
          </template>
        </form-wizard>
        <modal
          :show.sync="modals.confirmation"
          modal-classes="modal-dialog-centered"
        >
          <h6 slot="header" class="modal-title" id="modal-title-notification">
            Atenção!
          </h6>
          <div class="vld-parent" ref="modal_confirmation">
            <div class="py-3 text-center">
              <i class="fa fa-plane fa-3x"></i>
              <h4 class="heading mt-4">Quase lá!</h4>
              <p class="mt-3">
                Você realmente deseja concluir sua inscrição na seleção
                <span class="font-weight-bold">{{ process.title }}</span
                >?
              </p>
              <p class="text-sm">
                <i class="fas fa-info-circle mr-1"></i> Ao prosseguir, você
                confirma que os dados informados são verdadeiros.
              </p>
            </div>
          </div>
          <template slot="footer">
            <base-button
              type="link"
              text-color="dark"
              class="ml-auto"
              @click="modals.confirmation = false"
            >
              Voltar
            </base-button>
            <base-button
              class="finish-button"
              @click="handleSubmit"
              :disabled="modals.disabledSubmit"
            >
              Confirmar inscrição
            </base-button>
          </template>
        </modal>
        <modal
          :show.sync="modals.disc.show"
          modal-classes="modal-dialog-centered modal-xl"
          header-classes="pb-0"
          body-classes="py-0"
        >
          <h6 slot="header" class="modal-title" id="modal-title-notification">
            DISC -
            {{ modals.disc.perfil ? discInfo[modals.disc.perfil].perfil : "" }}
          </h6>
          <div>
            <div class="py-0 text-center" v-if="modals.disc.perfil">
              <i class="fa fa-chart-pie fa-3x"></i>
              <h4 class="heading mt-3">
                {{ discInfo[modals.disc.perfil].title }}
              </h4>
              <ul class="text-left mt-4">
                <li><b>Frase: </b> {{ discInfo[modals.disc.perfil].frase }}</li>
                <li>
                  <b>Características gerais: </b>
                  {{ discInfo[modals.disc.perfil].caracteristicas }}
                </li>
                <li>
                  <b>O que move os Dominantes? (motivação) </b>
                  <ul>
                    <li
                      v-for="(item, index) in discInfo[modals.disc.perfil]
                        .motivacao"
                      :key="'motivacao_' + index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Necessidade básica: </b>
                  {{ discInfo[modals.disc.perfil].necessidade }}
                </li>
                <li>
                  <b>Como reconhecê-los: </b>
                  <ul>
                    <li
                      v-for="(item, index) in discInfo[modals.disc.perfil]
                        .reconhecer"
                      :key="'reconhecer_' + index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Vantagens ou Forças: </b>
                  <ul>
                    <li
                      v-for="(item, index) in discInfo[modals.disc.perfil]
                        .vantagens"
                      :key="'vantagem_' + index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Desvantagens ou Debilidades: </b>
                  <ul>
                    <li
                      v-for="(item, index) in discInfo[modals.disc.perfil]
                        .desvantagens"
                      :key="'desvantagem' + index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Para melhorar a comunicação com um Dominante: </b>
                  <ul>
                    <li
                      v-for="(item, index) in discInfo[modals.disc.perfil]
                        .comunicacao_com"
                      :key="'ccom_' + index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </li>
                <li>
                  <b
                    >Como um Dominante pode melhorar sua comunicação com os
                    demais:
                  </b>
                  <ul>
                    <li
                      v-for="(item, index) in discInfo[modals.disc.perfil]
                        .comunicacao_melhorar"
                      :key="'cmelhorar_' + index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Tempo livre: </b>
                  {{ discInfo[modals.disc.perfil].tempo_livre }}
                </li>
                <li>
                  <b>Sobre pressão: </b>
                  {{ discInfo[modals.disc.perfil].pressao }}
                </li>
                <li>
                  <b>Caráter: </b> {{ discInfo[modals.disc.perfil].carater }}
                </li>
                <li><b>Medo: </b> {{ discInfo[modals.disc.perfil].medo }}</li>
                <li>
                  <b>Outras denominações: </b>
                  {{ discInfo[modals.disc.perfil].denominacoes }}
                </li>
                <li>
                  <b>Elemento associado: </b>
                  {{ discInfo[modals.disc.perfil].elemento }}
                </li>
              </ul>
            </div>
          </div>
          <template slot="footer">
            <base-button
              type="link"
              text-color="dark"
              class="ml-auto"
              @click="modals.disc.show = false"
            >
              Fechar
            </base-button>
          </template>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import ProgramaTab from "./ProgramaTab";

import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import VueApexCharts from "vue-apexcharts";

import api from "@/services/api.js";

export default {
  name: "inscricao",
  components: {
    ProgramaTab,
    FormWizard,
    TabContent,
    WizardButton,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      process: {
        title: "",
        status: "",
        external_link: "",
        region: "",
        start_date: "",
        end_date: "",
        keywords: "",
        description: "",
        observation: "",
        finished_message: "",
      },
      model: {
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
        linkedin_url: "",
        areas: [],
        gender: "",
        civil_status: "",
        birthday: "",
        nationality: "",
        homepage_url: "",
        github_url: "",
        education: [
          {
            institution: "",
            course: "",
            duration: "",
            start: "",
            end: "",
            status: "",
          },
        ],
        experiences: [
          {
            company: "",
            start: "",
            end: "",
            position: "",
            attributions: "",
          },
        ],
        note: "",
        languages: [
          {
            language: "",
            level: "",
          },
        ],
      },
      portfolio: null,
      areas: [
        "Co-criar um negócio",
        "Trabalhar na área de Comunicação e Marketing",
        "Trabalhar na área de TI",
        "Trabalhar na área Comercial",
        "Trabalhar na área de Gestão",
      ],
      genders: [
        "Homem cisgênero",
        "Homem Transgênero",
        "Mulher Cisgênero ",
        "Mulher Transgênero",
        "Outro",
        "Prefiro não responder",
      ],
      civilStatus: ["Solteiro", "Casado", "Separado", "Divorciado", "Viúvo"],
      survey: [
        {
          question:
            "Em um restaurante. Estou esperando uma mesa e o garçom me diz que em 10 minutos terei uma mesa, porém passam 20 minutos:",
          options: [
            "Me aborreço e digo ao garçom que já se passou o dobro do tempo, e lhe informo que se demorar muito irei embora e eles perderão um cliente.",
            "Não me dou conta pois estou envolvido em uma conversa.",
            "Não me fixo ao tempo, ainda que eu saiba do atraso, não falo nada.",
            "Informo ao Garçom exatamente a hora que cheguei e exatamente o tempo que passou e peço que por favor me diga com exatidão quanto tempo ainda falta para que eu possa tomar uma decisão.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question:
            "Tenho muita fome e pressa. O garçom me traz um prato que eu não pedi:",
          options: [
            "Digo de maneira direta que este não foi o prato que pedi.",
            "Chamo o garçom e converso com ele explicando que este não era o prato que eu havia pedido.",
            "Fico calado e aceito o prato que me trouxeram.",
            "Me incomodo e pergunto ao garçom de uma forma aborrecida se ele estava prestando atenção quando fiz meu pedido?",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Em uma reunião de amigos:",
          options: [
            "Eu gosto de convencer aos demais de minhas opiniões e gosto de falar sobre temas relacionados com meu trabalho.",
            "Escuto as pessoas. As pessoas me procuram pois sou um excelente ouvinte. Escuto as pessoas com atenção.",
            "Falo muito e conto bastante piadas. Geralmente falo mais do que escuto.",
            "Observo e analiso as pessoas, porém dou minha opinião. Todavia só dou minha opinião quando conheço o tema e quando o faço sou preciso.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Meus companheiros de trabalho me descrevem como alguém:",
          options: [
            "Tranquilo, Paciente, Amável.",
            "Social, Alegre, Gosta de Conversar.",
            "Enérgico, Forte, Agressivo.",
            "Concreto, Disciplinado, Metódico.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Em uma discussão:",
          options: [
            "Trato de dizer que não é para tanto, pois discutir me aborrece.",
            "Busco ter a razão e não paro até que consiga. Gosto de discutir.",
            "Odeio agressões, concordo com o que esta sendo dito para não precisar argumentar.",
            "Me baseio nos fatos e busco comprovar meu ponto de vista de uma forma fundamentada e também espero que os demais hajam assim.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "O que realmente me emociona na vida:",
          options: [
            "Os desafios, As novidades, Arriscar.",
            "As surpresas, A diversão, O jogo.",
            "A doçura, O carinho, Aceitação.",
            "Aprender, Sabedoria, Conhecimento.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Se alguém me agride:",
          options: [
            "Fico calado e não demonstro o que sinto.",
            "Escapo da situação ou pergunto a outra pessoa se ela é louca.",
            "Devolvo a agressão pois necessito demonstrar minha insatisfação de imediato. Da mesma forma que me incomodo rapidamente me tranquilizo.",
            "Me angustio, me privo e me resguardo, porém tento descobrir por que isso aconteceu. Demora algum tempo para que passe minha insatisfação com o acontecido.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Quando vou as compras:",
          options: [
            "Busco ofertas, os descontos me fascinam.",
            "Me divirto indo as compras. Gosto de comprar presentes, dizem que sou um comprador compulsivo.",
            "Sei o que quero e não gasto meu dinheiro se não encontro. Sou muito definido.",
            "Sou indeciso, me dá muito trabalho decidir e escolher.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Que frase te descreve melhor:",
          options: [
            "Sou tranquilo e passivo, gosto das pessoas que são fáceis de conviver e que não me agridam. As pessoas me perguntam se nunca me aborreço.",
            "Sou alegre e jovial. Se vejo alguém triste procuro levar alegria a está pesssoa. As pessoas me perguntam se nunca me deprimo.",
            "Sou ativo e enérgico, gosto de fazer várias coisas ao mesmo tempo, as pessoas perguntam se não me canso.",
            "Sou analítico e observador, gosto de resolver problemas que me exijam pensar e de encontrar soluções. As pessoas me dizem que sou muito responsável e apreensivo.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Quando estou trabalhando em equipe sou:",
          options: [
            "O que organiza a parte estratégica com finalidade de conseguir uma maior probabilidade de êxito.",
            "O que anima o ambiente fazendo com que todos tenham vontade.",
            "O que manda e organiza.",
            "O que apóia com propósito de se ter uma equipe unida.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question:
            "Meus irmãos e as pessoas que me rodeiam, dizem que meus piores defeitos são:",
          options: [
            "Ser teimoso e quadrado.",
            "Ser agressivo e temperamental.",
            "Ser submisso e lento.",
            "Ser distraído e desorganizado.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Alguma de minhas qualidades são:",
          options: [
            "Ser Determinado e seguro.",
            "Ser Adaptado e pacífico.",
            "Ser Otimista e alegre.",
            "Ser Cumpridor e estável.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Estou caminhando e esbarro com algum desconhecido:",
          options: [
            "Dou um passo ao lado e sem falar sigo meu caminho.",
            "Dou um sorriso e sigo em frente.",
            "Espero que a pessoa saia do meu caminho para poder seguir adiante.",
            "Peço que me desculpe e sigo em frente.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "No trabalho me sobressaio em:",
          options: [
            "Na tomada de decisões rapidamente.",
            "Nas relações públicas.",
            "Na capacidade de me adaptar a equipes.",
            "Na segurança de ter qualidade e pontualidade.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Meus defeitos no trabalho são:",
          options: [
            "Não gosto de delegar, prefiro trabalhar sozinho.",
            "Não gosto que me digam o que fazer.",
            "Trabalho mais sobre baixa pressão.",
            "Desordenado e esquecido e as vezes impontual.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Minha mãe diz que quando criança eu era:",
          options: [
            "Obediente e tranquilo.",
            "Mandão e exigente.",
            "Alegre e conversava com todo mundo.",
            "Bem arrumado e eu não gostava de me sujar.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Ao me expressar:",
          options: [
            "Falo as coisas de maneira diplomática.",
            "Quase não expresso o que sinto.",
            "Falo de maneira indireta para não magoar.",
            "Falo as coisas como são.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "A emoção que demonstro com mais frequência é:",
          options: [
            "Medo.",
            "Otimismo.",
            "Não demonstro emoção.",
            "Irritação.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Os professores me reconheciam por que:",
          options: [
            "Discutia muito e gostava de demonstrar tudo que eu sabia.",
            "Bom estudante e bastante analítico.",
            "Não interrompia e ficava calado.",
            "Era muito amigável e gostava de conversar.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Características que mais te descrevem:",
          options: [
            "Auto-suficiente e ambicioso.",
            "Preciso e exato.",
            "Cooperativo e adaptável.",
            "Despreocupado e popular.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Características que mais te descrevem:",
          options: [
            "Reservado e educado.",
            "Amigo e conversador.",
            "Tolerante e flexível.",
            "Valente e ousado.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Características que mais te descrevem:",
          options: [
            "Obstinado, determinação para me defender.",
            "Confiante, acredito nas pessoas.",
            "Prudente, gosto de refletir bem sobre as coisas.",
            "Pronto a servir, gosto de ajudar aos demais.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Características que mais te descrevem:",
          options: [
            "Brincalhão, chama a atenção das pessoas.",
            "Empreendedor, força de vontade.",
            "Generoso, se adapta aos demais.",
            "Cuidadoso, cautela ao tomar decisões.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Características que mais te descrevem:",
          options: [
            "Calmo, faz o que te pedem.",
            "Envolvente, motiva aos demais.",
            "Atrevido, crê em si próprio.",
            "Disciplinado, organizado e limpo.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Características que mais te descrevem:",
          options: [
            "Culto, busca ter conhecimento.",
            "Animado, alma da festa.",
            "Harmonioso, aberto a sugestões.",
            "Confrontante, gosta de argumentar.",
          ],
          answers: ["", "", "", ""],
        },
        {
          question: "Características que mais te descrevem:",
          options: [
            "Humilde, compassivo (condolente) com as pessoas.",
            "Carismático, atrai as pessoas, desinibido.",
            "Tem atitude, persuasivo, convincente.",
            "Sistemático, cético, precavido.",
          ],
          answers: ["", "", "", ""],
        },
      ],
      errors: {
        stepError: {
          show: false,
          text: "Por favor, preencha todos os campos obrigatórios (*) antes de continuar.",
        },
        discError: {
          show: false,
          text: "Por favor, preencha as opções de todas as questões com valores de 1 a 4 para completar o questionário.",
        },
        submitError: {
          show: false,
          text: "Ocorreu um erro ao realizar a inscrição. Verifique os dados e tente novamente.",
        },
      },
      chartOptions: {
        chart: {
          type: "bar",
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        title: { text: "DISC - Perfil comportamental" },
      },
      chartSeries: [],
      discInfo: {
        dominante: {
          perfil: "Dominante",
          title: "Ficha Técnica dos Dominantes",
          frase: "Fazer e impulsionar o mundo",
          caracteristicas: "Direto - Impositivo - Trabalhador Compulsivo",
          motivacao: ["Poder", "Controle", "Ser o melhor", "Resultados"],
          necessidade: "CONTROLE",
          reconhecer: [
            "Energia exorbitante, segurança de si mesmo, tom de voz forte, opiniões contundentes.",
            "Ao caminhar: pisada forte, segura, sempre olha para frente e para os olhos das pessoas.",
            "Em uma reunião: fala somente de temas que interessam a si próprio e que ele pode ser superior.",
            "Em um seminário: atitudes desafiadoras, acredita saber mais que o expositor.",
            "Por sua forma de vestir: reflete poder e autoridade, status e êxito, gosta de ser considerado importante.",
            "Pela maneira de se expressar: direto, mandão, impositivo. Fala rápido, gosta de convencer os demais.",
            "No escritório: é o mais ativo, faz mais de uma coisa por vez. Líder nato, se enfoca em uma meta final.",
            "Seu sentido mais desenvolvido: tato.",
          ],
          vantagens: [
            "Perseverança - Adora desafios.",
            "Energia - Quer abraçar o mundo.",
            "Visão - Não existem obstáculos insuperáveis.",
          ],
          desvantagens: [
            "Egocêntrico - Auto-estima alta, insensível.",
            "Explosivo - Primeiro reage, depois pensa.",
            "Mandão - Exige que o que ele pede seja feito o mais rápido possível.",
            "Manipulador - Faz tudo que pode para ter o controle.",
            "Impaciente, Agressivo.",
          ],
          comunicacao_com: [
            "Seja suave, dê seu lugar a ele, peça as coisas com boas maneiras...",
            "Elogie-o...",
            "Espere até que ele se tranquilize...",
            "Vá direto ao ponto...",
            "Se mantenha tranquilo...",
            "Pergunte, não adivinhe...",
          ],
          comunicacao_melhorar: [
            "Se concentre nas pessoas...",
            "Não interrompa os outros...",
            "Tenha cuidado com o que diz...",
            "Seja humilde...",
            "Evite as chantagens...",
            "Cuide do seu tom de voz...",
          ],
          tempo_livre: "Atividades em geral",
          pressao:
            "Explora, agride, se motiva ainda mais para atingir suas metas",
          carater: "Extrovertido",
          medo: "De perder o controle",
          denominacoes: "Autoritário, agressivo",
          elemento: "Fogo",
        },
        influente: {
          perfil: "Influente",
          title: "Ficha Técnica dos Influentes",
          frase: "A inspiração e a alegria do mundo",
          caracteristicas: "Confia nos demais - Entusiasmado - Confiante",
          motivacao: ["Divertido", "Popular", "Aceitação", "Conexão Emocional"],
          necessidade: "ATENÇÃO",
          reconhecer: [
            "Por sua alegria, por falar constantemente, é amigável, impontual, distraído.",
            "Ao caminhar: canta e fala sozinho.",
            "Em uma reunião: as pessoas se aglutinam e fazem um círculo ao seu redor.",
            "Em um seminário: muito emocionado por conhecer novas pessoas. Se senta onde tem mais pessoas.",
            "Por sua forma de vestir: são criativos e originais, escolhem roupas divertidas. Preferem cores chamativas.",
            'Pela forma que se expressa: gesticula todo o tempo, fazem "caras e bocas", movem as mãos.',
            "No escritório: sempre estão conversando com alguma pessoa. Organizam confraternizações.",
            "Seu sentido mais desenvolvido: paladar.",
          ],
          vantagens: [
            "Brincalhão e Divertido - Busca alegria em tudo que faz.",
            "Otimista - Energia positiva. Vê o lado positivo de tudo até das piores situações.",
            "Entusiasta - Dificilmente se deprime. Não dão tanta seriedade as coisas.",
            'Despreocupado - "Para que  se preocupar? De todas as formas tudo vai dar certo."',
            "Efusivo - Gritam, saltam, esperneiam e aplaudem quando ganham um prêmio.",
          ],
          desvantagens: [
            "Esquecido e Distraído - Falta de concentração. Às vezes seus descuidos parecem ser de propósito.",
            "Não terminam o que começam - Lhes fascina iniciar projetos, porém somente iniciá-los, raramente os concluem.",
            "Evasivo - São muito hábeis em se desvincular de responsabilidades, culpas e erros.",
            "Exagerado - Quando relatam uma história a convertem em algo extraordinário.",
            "Desorganizado.",
          ],
          comunicacao_com: [
            "Seja cálido e pessoal...",
            "Mostre apreço por seu idealismo e por seu otimismo...",
            "Compartilhe seu entusiasmo...",
            "Seja paciente...",
            "Ajude-os a aterrissar...",
            "Peça que tomem e que tenham um rumo...",
          ],
          comunicacao_melhorar: [
            "Falar menos e escutar mais...",
            "Seja o mais claro possível...",
            "Observe a comunicação não verbal, dos demais...",
            "Evite exagerar...",
            "Cuide dos monólogos...",
          ],
          tempo_livre: "Está em contato com pessoas",
          pressao:
            "Dá desculpas, não se responsabiliza, minimiza problemas, é evasivo, dá pretextos",
          carater: "Extrovertido",
          medo: "Ser considerado chato e não ser aceito",
          denominacoes: "Social, Sanguíneo, Catalisador",
          elemento: "Ar",
        },
        estavel: {
          perfil: "Estável",
          title: "Ficha Técnica dos Estáveis",
          frase: "A paz e a tranquilidade do mundo",
          caracteristicas:
            'Não sabem dizer "Não" - Inexpressivo - Evita o confronto - Detalhista',
          motivacao: [
            "Aprovação",
            "Servir aos demais",
            "Evitar conflitos",
            "Estabilidade",
          ],
          necessidade: "PAZ",
          reconhecer: [
            "Por sua tranquilidade, atitude adaptável, lentidão ao falar e caminhar, calado.",
            "Ao caminhar: vai com toda a calma do mundo, nunca tem pressa.",
            "Em uma reunião: são sutis e discretos. Permanecem sentados e quase não falam, gostam de escutar.",
            "Em um seminário: gosta de se superar e de aprender de tudo. Sua humildade é a prova de balas.",
            "Pela forma de se vestir: discreto e conservador. Usam cores que não chama a atenção.",
            "Pela forma que se expressa: são calmos e gentis. Sua maneira de falar é lenta e suave. Equilibrado.",
            "No escritório: não se irrita e nem fica nervoso (ao menos demonstra isso). Se entrega as tarefas. Paz.",
            "Seu sentido mais desenvolvido: audição.",
          ],
          vantagens: [
            'Fácil de levar - São os que dizem "sim" a todo mundo. Contagiam por sua paz e estabilidade.',
            "Paciente - São a prova de tudo.",
            "Ninguém pode reduzir sua tranquilidade e sua paciência.",
            "Bons para escutar - Deixam de lado suas atividades para escutar. Não julgam.",
          ],
          desvantagens: [
            "Inseguro - Tem problemas para expor seus pontos de vista e seus desejos.",
            "Desmotivado - Necessita constantemente que reafirmem seus feitos e avanços.",
            "Entediado - São em princípio passivos, não assumem risco e nem buscam novidades. Monotonia.",
            "Indeciso - Batalha para tomar uma decisão. Busca sempre um suporte para decidir algo.",
          ],
          comunicacao_com: [
            "Mantenha a tranquilidade...",
            "Utilize um tom amável...",
            "Faça perguntas...",
            "Inspire segurança...",
            "Utilize empatia e atenção",
            "Seja sensível a suas emoções",
            "Dê tempo para que ele se decida...",
          ],
          comunicacao_melhorar: [
            "Seja assertivo...",
            'Diga "não"...',
            "Não leve as coisas para o lado pessoal...",
            "Expresse suas emoções...",
            "Valorize seus comentários...",
          ],
          tempo_livre: "Família",
          pressao: "Se esconde, não funciona, congela, quer desaparecer",
          carater: "Introvertido",
          medo: "De se confrontar, de agressões e principalmente das MUDANÇAS",
          denominacoes: "Paciente, Sereno, agressivo",
          elemento: "Água",
        },
        condescendente: {
          perfil: "Condescendente",
          title: "Ficha Técnica dos Condescendente ou Analíticos",
          frase: "Estrategistas e filósofos da vida",
          caracteristicas: "Dedicado - Detalhista - Confiável - Não Delegam",
          motivacao: [
            "Seus espaços (independência, privacidade)",
            "Informação e procedimentos",
            "Desafios mentais",
            "Ter a razão",
            "Reconhecimento e aprovação",
          ],
          necessidade: "ORDEM",
          reconhecer: [
            "Fala corretamente e com fundamentos, é limpo e cuida de seus aspectos físicos.",
            "Ao caminhar: vai direto ao seu destino. É cortês porém com um semblante sério, não sorri. Concentrado.",
            'Em uma reunião: reconhece os "novos" e observa detalhadamente. Fica sempre no mesmo lugar.',
            "Em um seminário: está atento as credenciais e no currículo do expositor. Faz anotações organizadas.",
            "Forma de se vestir: são sóbrios e elegantes.",
            "Pela forma de se expressar: não falam muito, pensam bem antes de dizer algo. São diretos e claros.",
            "No escritório: não promove jogos pelo poder, se mantém alheio aos interesses dos outros.",
            "Seu sentido mais desenvolvido: visão.",
          ],
          vantagens: [
            "Comprometido e leal - Os princípios ético são os mais importantes. Dificilmente se chateiam ou são infiéis.",
            "Consideração - Antes de tomar uma decisão consulta os envolvidos.",
            "Profundo e Espiritual - Valorizam muito a dimensão mística da vida.",
          ],
          desvantagens: [
            "Muito exigentes - Se empenham em tirar dez em tudo que fazem. Falhar não está em seu vocabulário.",
            "Apreensivo - Levam tudo a sério. Tudo é de vital importância. Tudo lhes parece transcendental e crítico.",
            "Teimoso - Não muda de opinião.",
            "Pessimista - Sempre vê algo negativo nas coisas.",
            "Perfeccionista - Investe muito tempo e energia para que o mundo seja perfeito.",
          ],
          comunicacao_com: [
            "Seja claro, conciso e concreto...",
            "Se não está de acordo, prove o contrário...",
            "Seja organizado e preciso...",
            "Utilize as palavras corretas",
            "Dê tempo para pensar...",
            "Leve-os em consideração...",
            "Respeite seu silêncio...",
          ],
          comunicacao_melhorar: [
            "Seja menos literal...",
            "Coloque interesse ao escutar...",
            "Fale as coisas na hora...",
            "Seja mais aberto...",
          ],
          tempo_livre: "Privacidade",
          pressao:
            "Se fecha, se deprime, se martiriza, exige muito de si próprio",
          carater: "Introvertido",
          medo: "Do Irracional, de equivocar-se, de não ser compreendido",
          denominacoes: "Analítico, Cumpridor, Melancólico",
          elemento: "Terra",
        },
      },
      modals: {
        confirmation: false,
        disabledSubmit: false,
        disc: {
          perfil: "",
          show: false,
        },
      },
      success: false,
      error: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.programa_container,
      width: 140,
      height: 140,
      opacity: 1,
    });
    try {
      const { data } = await api.get(
        `/recruitment-processes/${this.$route.params.slug}`
      );
      if (data.keywords)
        data.keywords = data.keywords.split(";").filter((s) => s);
      Object.assign(this.process, data);
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.error = true;
    } finally {
      loader.hide();
    }
  },
  methods: {
    async handleSubmit() {
      this.modals.disabledSubmit = true;
      this.errors.submitError.show = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation,
        opacity: 0,
        width: 140,
        height: 140,
      });
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      const data = new FormData();
      data.append("model", JSON.stringify(this.model));
      data.append("disc", JSON.stringify(this.survey.map((q) => q.answers)));
      if (this.portfolio)
        data.append("portfolio", this.portfolio, this.portfolio.name);

      try {
        await api.post(
          `/recruitment-processes/${this.$route.params.slug}/subscriptions`,
          data,
          config
        );
        const discResult = [
          {
            x: "Dominante",
            y: this.survey.reduce((acc, q) => acc + Number(q.answers[0]), 0),
            fillColor: "#FF0000",
          },
          {
            x: "Influente",
            y: this.survey.reduce((acc, q) => acc + Number(q.answers[1]), 0),
            fillColor: "#EDD42F",
          },
          {
            x: "Estável",
            y: this.survey.reduce((acc, q) => acc + Number(q.answers[2]), 0),
            fillColor: "#0A820A",
          },
          {
            x: "Condescendente",
            y: this.survey.reduce((acc, q) => acc + Number(q.answers[3]), 0),
            fillColor: "#0000FF",
          },
        ];
        this.chartSeries.push({
          name: "Pontuação",
          data: discResult,
        });
        this.$toasted.show("Inscrição concluída com sucesso!");
        this.modals.confirmation = false;
        this.success = true;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao concluir a inscrição");
        this.errors.submitError.show = true;
        this.modals.confirmation = false;
      } finally {
        loader.hide();
        this.modals.disabledSubmit = false;
      }
    },
    onComplete: function () {
      if (this.validateDisc()) {
        this.modals.confirmation = true;
      }
    },
    validateCv() {
      const model = this.model;
      if (!model.education.length) {
        this.errors.stepError.show = true;
        return false;
      }
      const requiredKeys = [
        "name",
        "phone",
        "email",
        "state",
        "city",
        "area",
        "gender",
        "civil_status",
        "birthday",
        "nationality",
      ];
      for (const key of requiredKeys) {
        if (model[key] === "" || model[key] === null) {
          this.errors.stepError.show = true;
          return false;
        }
      }
      this.errors.stepError.show = false;
      return true;
    },
    validateDisc() {
      for (const question of this.survey) {
        for (const answer of question.answers) {
          if (answer === "" || !(answer >= 1 || answer <= 4)) {
            this.errors.discError.show = true;
            return false;
          }
        }
      }
      this.errors.discError.show = false;
      return true;
    },
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    addEducation() {
      this.model.education.push({
        institution: "",
        course: "",
        duration: "",
        start: "",
        end: "",
        status: "",
      });
    },
    removeEducation(index) {
      this.model.education.splice(index, 1);
    },
    addExperience() {
      this.model.experiences.push({
        company: "",
        start: "",
        end: "",
        position: "",
        attributions: "",
      });
    },
    removeExperience(index) {
      this.model.experiences.splice(index, 1);
    },
    addLanguage() {
      this.model.languages.push({
        language: "",
        level: "",
      });
    },
    removeLanguage(index) {
      this.model.languages.splice(index, 1);
    },
    getRemainingOptions(current, answers) {
      const selecetedValues = answers.slice();
      selecetedValues.splice(current, 1);
      return ["1", "2", "3", "4"].filter((v) => !selecetedValues.includes(v));
    },
    openModalDisc(perfil) {
      this.modals.disc.perfil = perfil;
      this.modals.disc.show = true;
    },
    handleAreaSelected(option, event) {
      if (event) {
        if (!this.model.areas.includes(option)) {
          this.model.areas.push(option);
        }
      } else {
        this.model.areas = this.model.areas.filter((area) => area !== option);
      }
    },
  },
  computed: {
    isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.finish-button {
  background-color: #43a047 !important;
  border-color: #43a047 !important;
}
.finish-button:hover,
.finish-button:focus,
.finish-button:active {
  background-color: #1e8623 !important;
  border-color: #1e8623 !important;
}

.vue-form-wizard .wizard-btn {
  padding: 9px 12px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
<style>
.vue-form-wizard .wizard-nav-pills > li > a span.stepTitle:not(.active) {
  color: #bbbbbb !important;
}
</style>
